import { Logo } from "src/elements/logo";
import { Text } from "src/elements/text";
import styled from "styled-components"

const Div = styled.div`
    /* Use grid for precise alignment */
    display: grid;
    justify-items: center; /* Center horizontally */
    width: 100%;
    max-width: 700px; /* Control maximum width */
    margin: 0 auto;
    
    /* Create a consistent width column for content */
    grid-template-columns: minmax(auto, 550px);
    
    .welcomeText {
        color: #fff;
        font-size: 80px;
        text-align: center;
        width: 100%; /* Full width of the grid cell */
    }
    
    .welComeLogo {
        width: 100%;
        max-width: 700px;
        height: auto;
        margin: 44px 0;
        justify-self: center; /* Center in grid cell */
    }

    .url {
        font-weight: normal;
        font-size: 50px;
        line-height: 80px;
    }
    
    .roomCode {
        margin-top: 20px; /* Add specific spacing */
        white-space: nowrap; /* Keep room code on one line */
        display: flex;
        justify-content: center;
        gap: 10px; /* Add space between text and code */
    }
`;

type Props = {
    roomCode?: number | string,
}

export const StudioWelComeScreen = ({ roomCode }: Props ) => {

    return (
        <Div>
            <Text className="welcomeText">Welcome to</Text>
            <Logo className="welComeLogo"/>
            <Text className="welcomeText url">Visit instantmil.com</Text>
            <Text className="welcomeText roomCode">
                <span>Your room code:</span> 
                <span>{roomCode}</span>
            </Text>
        </Div>
    )

}